import { Box, Typography, LinearProgress } from '@mui/material'
import { useState, useEffect } from 'react'
import { DotLottieReact } from '@lottiefiles/dotlottie-react'

const DEFAULT_DURATION = 5000 // ms
const STEPS = 100

export default function CreateConciergeAnimation() {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const intervalTime = DEFAULT_DURATION / STEPS
    let current = 0

    const timer = setInterval(() => {
      current += 1
      setProgress(current)

      if (current >= STEPS) {
        clearInterval(timer)
        window.location.href = '/web-concierge'
      }
    }, intervalTime)

    return () => clearInterval(timer)
  }, [])

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      justifyContent='center'
      textAlign='center'
      px={2}
      py={4}
    >
      <Typography variant='h5' gutterBottom>
        Creating your concierge…
      </Typography>
      <Typography variant='body1' color='text.secondary' mb={3}>
        This should only take a moment!
      </Typography>

      <DotLottieReact
        src='https://lottie.host/1416c383-b959-4792-b477-5f7e2c250c8a/mn0rZkhvKY.lottie'
        loop
        autoplay
        speed={1.5}
        style={{ width: 220, height: 220 }}
      />

      <Box mt={4} width='75%'>
        <LinearProgress
          variant='determinate'
          value={progress}
          sx={{
            height: 8,
            borderRadius: 4,
            backgroundColor: 'grey.200',
            '& .MuiLinearProgress-bar': {
              backgroundColor: 'primary.main',
            },
          }}
        />
      </Box>
    </Box>
  )
}
